import { MENU_KEY, SUBMENU_KEY } from '../pages/landing/json_data';
import { ROUTER } from './router';

const MENU_KEY_SUBMENU = {
    DATA_CATALOG: MENU_KEY.DATA_CATALOG,
    DATA_INVENTORY: MENU_KEY.DATA_INVENTORY,
    DATA_INVENTORY_DASHBOARD: `${MENU_KEY.DATA_INVENTORY} ${SUBMENU_KEY.DATA_INVENTORY.DASHBOARD}`,
    DATA_INVENTORY_DATAFLOW: `${MENU_KEY.DATA_INVENTORY} ${SUBMENU_KEY.DATA_INVENTORY.DATAFLOW}`,
    DATA_INVENTORY_ROPA: `${MENU_KEY.DATA_INVENTORY} ${SUBMENU_KEY.DATA_INVENTORY.ROPA}`,
    RISK_MANAGEMENT: MENU_KEY.RISK_MANAGEMENT,
    RISK_MANAGEMENT_DASHBOARD: `${MENU_KEY.RISK_MANAGEMENT} ${SUBMENU_KEY.RISK_MANAGEMENT.DASHBOARD}`,
    RISK_MANAGEMENT_RA: `${MENU_KEY.RISK_MANAGEMENT} ${SUBMENU_KEY.RISK_MANAGEMENT.RISK_ASSESSMENT}`,
    RISK_MANAGEMENT_RR: `${MENU_KEY.RISK_MANAGEMENT} ${SUBMENU_KEY.RISK_MANAGEMENT.RISK_REGISTER}`,
    DPIA: MENU_KEY.DPIA,
    PRIVACY_POLICY: MENU_KEY.PRIVACY_POLICY,
    CONSENT_MANAGEMENT: MENU_KEY.CONSENT_MANAGEMENT,
    CONSENT_MANAGEMENT_DASHBOARD: `${MENU_KEY.CONSENT_MANAGEMENT} ${SUBMENU_KEY.CONSENT_MANAGEMENT.DASHBOARD}`,
    CONSENT_MANAGEMENT_CONSENT: `${MENU_KEY.CONSENT_MANAGEMENT} ${SUBMENU_KEY.CONSENT_MANAGEMENT.CONSENT_FORM}`,
    CONSENT_MANAGEMENT_TEMPLATE_DESIGN: `${MENU_KEY.CONSENT_MANAGEMENT} ${SUBMENU_KEY.CONSENT_MANAGEMENT.TEMPLATE_DESIGN}`,
    CONSENT_MANAGEMENT_MANANGE_CONSENT: `${MENU_KEY.CONSENT_MANAGEMENT} ${SUBMENU_KEY.CONSENT_MANAGEMENT.MANAGE_CONSENT}`,
    CONSENT_MANAGEMENT_IMPORT_CONSENT: `${MENU_KEY.CONSENT_MANAGEMENT} ${SUBMENU_KEY.CONSENT_MANAGEMENT.IMPORT_CONSENT}`,
    COOKIE_MANAGEMENT: MENU_KEY.COOKIE_MANAGEMENT,
    COOKIE_MANAGEMENT_DASHBOARD: `${MENU_KEY.COOKIE_MANAGEMENT} ${SUBMENU_KEY.COOKIE_MANAGEMENT.DASHBOARD}`,
    COOKIE_MANAGEMENT_COOKIE_SCANNER: `${MENU_KEY.COOKIE_MANAGEMENT} ${SUBMENU_KEY.COOKIE_MANAGEMENT.COOKIE_SCANNER}`,
    COOKIE_MANAGEMENT_COOKIE_CATEGORY: `${MENU_KEY.COOKIE_MANAGEMENT} ${SUBMENU_KEY.COOKIE_MANAGEMENT.COOKIE_CATEGORY}`,
    COOKIE_MANAGEMENT_CUSTOMIZE_BANNER: `${MENU_KEY.COOKIE_MANAGEMENT} ${SUBMENU_KEY.COOKIE_MANAGEMENT.CUSTOMIZE_BANNER}`,
    DATA_SUBJECT_MANAGEMENT: MENU_KEY.DATA_SUBJECT_MANAGEMENT,
    DATA_SUBJECT_MANAGEMENT_DASHBOARD: `${MENU_KEY.DATA_SUBJECT_MANAGEMENT} ${SUBMENU_KEY.DATA_SUBJECT_MANAGEMENT.DASHBOARD}`,
    DATA_SUBJECT_MANAGEMENT_MY_TASK: `${MENU_KEY.DATA_SUBJECT_MANAGEMENT} ${SUBMENU_KEY.DATA_SUBJECT_MANAGEMENT.MY_TASK}`,
    DATA_SUBJECT_MANAGEMENT_DS_REQUEST_FORM: `${MENU_KEY.DATA_SUBJECT_MANAGEMENT} ${SUBMENU_KEY.DATA_SUBJECT_MANAGEMENT.DS_REQUEST_FORM}`,
    DATA_SUBJECT_MANAGEMENT_WORKFLOW: `${MENU_KEY.DATA_SUBJECT_MANAGEMENT} ${SUBMENU_KEY.DATA_SUBJECT_MANAGEMENT.WORKFLOW}`,
    DATA_SUBJECT_MANAGEMENT_IMPORT_DS_REQUEST: `${MENU_KEY.DATA_SUBJECT_MANAGEMENT} ${SUBMENU_KEY.DATA_SUBJECT_MANAGEMENT.IMPORT_DS_REQUEST}`,
    DATA_INQUIRY: MENU_KEY.DATA_INQUIRY,
    DATA_BREACH: MENU_KEY.DATA_BREACH,
    DATA_BREACH_DASHBOARD: `${MENU_KEY.DATA_BREACH} ${SUBMENU_KEY.DATA_BREACH.DASHBOARD}`,
    DATA_BREACH_LOG: `${MENU_KEY.DATA_BREACH} ${SUBMENU_KEY.DATA_BREACH.DATA_BREACH_LOG}`,
    DATA_BREACH_FORM: `${MENU_KEY.DATA_BREACH} ${SUBMENU_KEY.DATA_BREACH.DATA_BREACH_FORM}`,
    DATA_BREACH_RESPONSIBILITY: `${MENU_KEY.DATA_BREACH} ${SUBMENU_KEY.DATA_BREACH.RESPONSIBILITY}`,
    CONFIGURATION: MENU_KEY.CONFIGURATION,
    CONFIGURATION_USER_MANAGEMENT: `${MENU_KEY.CONFIGURATION} ${SUBMENU_KEY.CONFIGURATION.USER_MANAGEMENT}`,
    CONFIGURATION_DC_DPO: `${MENU_KEY.CONFIGURATION} ${SUBMENU_KEY.CONFIGURATION.DC_DPO}`,
    CONFIGURATION_DATA_CATALOG: `${MENU_KEY.CONFIGURATION} ${SUBMENU_KEY.CONFIGURATION.DATA_CATALOG}`,
    CONFIGURATION_UPGRADE_PLAN: `${MENU_KEY.CONFIGURATION} ${SUBMENU_KEY.CONFIGURATION.YOUR_PLAN}`,
    CONFIGURATION_EMAIL_SETTING: `${MENU_KEY.CONFIGURATION} ${SUBMENU_KEY.CONFIGURATION.EMAIL_SETTING}`,
};

const MenuList = ({ t, setOpenDs }) => {
    return [
        {
            keyPermission: MENU_KEY_SUBMENU.DATA_CATALOG,
            key: `ds-catalog`,
            label: (
                <button type="button" onClick={() => setOpenDs(true)}>
                    {t('common.DataCatalog')}
                </button>
            ),
            icon: MENU_ICON.CONFIGURATION,
            disabled: true,
        },
        {
            keyPermission: MENU_KEY_SUBMENU.DATA_INVENTORY,
            key: ROUTER.DS_INVENTORY.DEFAULT,
            label: t('common.DataInventory'),
            icon: MENU_ICON.DATA_INVENTORY,
            children: [
                {
                    keyPermission: MENU_KEY_SUBMENU.DATA_INVENTORY_DASHBOARD,
                    key: ROUTER.DS_INVENTORY.DASHBOARD,
                    label: t('common.Dashboard'),
                },
                {
                    keyPermission: MENU_KEY_SUBMENU.DATA_INVENTORY_DATAFLOW,
                    key: ROUTER.DS_INVENTORY.DATAFLOW,
                    label: t('common.DataFlow'),
                },
                {
                    keyPermission: MENU_KEY_SUBMENU.DATA_INVENTORY_ROPA,
                    key: ROUTER.DS_INVENTORY.ROPA,
                    label: t('common.RoPa'),
                },
            ],
        },
        {
            keyPermission: MENU_KEY_SUBMENU.RISK_MANAGEMENT,
            key: ROUTER.RISK_MANAGEMENT.DEFAULT,
            label: t('common.RiskManagement'),
            icon: MENU_ICON.RISK_MANAGEMENT,
            children: [
                {
                    keyPermission: MENU_KEY_SUBMENU.RISK_MANAGEMENT_DASHBOARD,
                    key: ROUTER.RISK_MANAGEMENT.DASHBOARD,
                    label: t('common.Dashboard'),
                },
                {
                    keyPermission: MENU_KEY_SUBMENU.RISK_MANAGEMENT_RA,
                    key: ROUTER.RISK_MANAGEMENT.RA,
                    label: t('common.RiskAssessment'),
                },
                {
                    keyPermission: MENU_KEY_SUBMENU.RISK_MANAGEMENT_RR,
                    key: ROUTER.RISK_MANAGEMENT.RR,
                    label: t('common.RiskRegister'),
                },
            ],
        },
        {
            keyPermission: MENU_KEY_SUBMENU.DPIA,
            key: ROUTER.DPIA.DEFAULT,
            label: 'DPIA',
            icon: MENU_ICON.DPIA,
        },
        {
            keyPermission: MENU_KEY_SUBMENU.COOKIE_MANAGEMENT,
            key: ROUTER.COOKIE_MANAGEMENT.DEFAULT,
            label: t('common.CookieManagement'),
            icon: MENU_ICON.COOKIE_MANAGEMENT,
            children: [
                {
                    keyPermission: MENU_KEY_SUBMENU.COOKIE_MANAGEMENT_DASHBOARD,
                    key: ROUTER.COOKIE_MANAGEMENT.DASHBOARD,
                    label: t('common.Dashboard'),
                },
                {
                    keyPermission:
                        MENU_KEY_SUBMENU.COOKIE_MANAGEMENT_COOKIE_SCANNER,
                    key: ROUTER.COOKIE_MANAGEMENT.COOKIE_SCANNER,
                    label: t('common.CookieScanner'),
                },
                {
                    keyPermission:
                        MENU_KEY_SUBMENU.COOKIE_MANAGEMENT_COOKIE_CATEGORY,
                    key: ROUTER.COOKIE_MANAGEMENT.COOKIE_CATEGORY,
                    label: t('common.CookieCategory'),
                },
                {
                    keyPermission:
                        MENU_KEY_SUBMENU.COOKIE_MANAGEMENT_CUSTOMIZE_BANNER,
                    key: ROUTER.COOKIE_MANAGEMENT.CUSTOMIZE_BANNER,
                    label: t('common.CookieBanner'),
                },
            ],
        },
        {
            keyPermission: MENU_KEY_SUBMENU.DATA_SUBJECT_MANAGEMENT,
            key: ROUTER.DS_360.DEFAULT,
            label: t('DataSubject360'),
            icon: MENU_ICON.DATA_SUBJECT_MANAGEMENT,
            children: [
                {
                    keyPermission:
                        MENU_KEY_SUBMENU.DATA_SUBJECT_MANAGEMENT_DASHBOARD,
                    key: ROUTER.DS_360.DASHBOARD,
                    label: t('common.DSDashboard360'),
                },
                {
                    keyPermission:
                        MENU_KEY_SUBMENU.DATA_SUBJECT_MANAGEMENT_MY_TASK,
                    key: ROUTER.DS_360.MY_TASK,
                    label: t('common.MyTask'),
                },
                {
                    keyPermission:
                        MENU_KEY_SUBMENU.DATA_SUBJECT_MANAGEMENT_DS_REQUEST_FORM,
                    key: ROUTER.DS_360.DS_REQUEST_FORM,
                    label: t('DS Request Form'),
                },
                {
                    keyPermission:
                        MENU_KEY_SUBMENU.DATA_SUBJECT_MANAGEMENT_WORKFLOW,
                    key: ROUTER.DS_360.WORKFLOW,
                    label: t('Workflow'),
                },
                {
                    keyPermission:
                        MENU_KEY_SUBMENU.DATA_SUBJECT_MANAGEMENT_IMPORT_DS_REQUEST,
                    key: ROUTER.DS_360.IMPORT_DS_REQUEST,
                    label: t('Import DS Request'),
                },
            ],
        },
        {
            keyPermission: MENU_KEY_SUBMENU.PRIVACY_POLICY,
            key: ROUTER.POLICY.DEFAULT,
            label: t('common.Policy'),
            icon: MENU_ICON.PRIVACY_POLICY,
        },
        {
            keyPermission: MENU_KEY_SUBMENU.CONSENT_MANAGEMENT,
            key: ROUTER.CONSENT_MANAGEMENT.DEFAULT,
            label: t('common.ConsentManagement'),
            icon: MENU_ICON.CONSENT_MANAGEMENT,
            children: [
                {
                    keyPermission:
                        MENU_KEY_SUBMENU.CONSENT_MANAGEMENT_DASHBOARD,
                    key: ROUTER.CONSENT_MANAGEMENT.DASHBOARD,
                    label: t('Dashboard'),
                },
                {
                    keyPermission: MENU_KEY_SUBMENU.CONSENT_MANAGEMENT_CONSENT,
                    key: ROUTER.CONSENT_MANAGEMENT.CONSENT,
                    label: t('common.Consent'),
                },
                {
                    keyPermission:
                        MENU_KEY_SUBMENU.CONSENT_MANAGEMENT_TEMPLATE_DESIGN,
                    key: ROUTER.CONSENT_MANAGEMENT.TEMPLATE_DESIGN,
                    label: t('Template Design'),
                },
                {
                    keyPermission:
                        MENU_KEY_SUBMENU.CONSENT_MANAGEMENT_MANANGE_CONSENT,
                    key: ROUTER.CONSENT_MANAGEMENT.MANANGE_CONSENT,
                    label: t('common.ManageConsent'),
                },
                {
                    keyPermission:
                        MENU_KEY_SUBMENU.CONSENT_MANAGEMENT_IMPORT_CONSENT,
                    key: ROUTER.CONSENT_MANAGEMENT.IMPORT_CONSENT,
                    label: t('Import Consent'),
                },
            ],
        },
        {
            keyPermission: MENU_KEY_SUBMENU.DATA_BREACH,
            key: ROUTER.DATA_BREACH.DEFAULT,
            label: t('Data Breach'),
            icon: MENU_ICON.DATA_BREACH,
            children: [
                {
                    keyPermission: MENU_KEY_SUBMENU.DATA_BREACH_DASHBOARD,
                    key: ROUTER.DATA_BREACH.DASHBOARD,
                    label: t('Dashboard'),
                },
                {
                    keyPermission: MENU_KEY_SUBMENU.DATA_BREACH_LOG,
                    key: ROUTER.DATA_BREACH.LOG,
                    label: t('Data Breach Log'),
                },
                {
                    keyPermission: MENU_KEY_SUBMENU.DATA_BREACH_FORM,
                    key: ROUTER.DATA_BREACH.FORM,
                    label: t('Data Breach Form'),
                },
                {
                    keyPermission: MENU_KEY_SUBMENU.DATA_BREACH_RESPONSIBILITY,
                    key: ROUTER.DATA_BREACH.RESPONSIBILITY,
                    label: t('Responsibility'),
                },
            ],
        },
        {
            keyPermission: MENU_KEY_SUBMENU.DATA_INQUIRY,
            key: ROUTER.DATA_INQUIRY.DEFAULT,
            label: t('common.DataInquiry'),
            icon: MENU_ICON.DATA_INQUIRY,
        },
        {
            keyPermission: MENU_KEY_SUBMENU.CONFIGURATION,
            key: ROUTER.CONFIGURATION.DEFAULT,
            label: t('common.Configuration'),
            icon: MENU_ICON.CONFIGURATION,
            children: [
                {
                    keyPermission:
                        MENU_KEY_SUBMENU.CONFIGURATION_USER_MANAGEMENT,
                    key: ROUTER.CONFIGURATION.USER_MANAGEMENT,
                    label: t('common.UserManagement'),
                },
                {
                    keyPermission: MENU_KEY_SUBMENU.CONFIGURATION_DC_DPO,
                    key: ROUTER.CONFIGURATION.DC_DPO,
                    label: t('common.DC&DPO'),
                },
                {
                    keyPermission: MENU_KEY_SUBMENU.CONFIGURATION_DATA_CATALOG,
                    key: ROUTER.CONFIGURATION.DATA_CATALOG,
                    label: t('common.DataCatalog'),
                },
                {
                    keyPermission: MENU_KEY_SUBMENU.CONFIGURATION_UPGRADE_PLAN,
                    key: ROUTER.CONFIGURATION.YOUR_PLAN,
                    label: t('Your Plan'),
                },
                {
                    keyPermission: MENU_KEY_SUBMENU.CONFIGURATION_EMAIL_SETTING,
                    key: ROUTER.CONFIGURATION.EMAIL_SETTING,
                    label: t('common.EmailSetting'),
                },
            ],
        },
    ];
};

const MENU_ICON = {
    DATA_CATALOG: (
        <svg
            width={16}
            height={14}
            viewBox="0 0 16 14"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M15.3125 0.830079H11.2906C10.4275 0.830079 9.58379 1.07793 8.85781 1.54551L8 2.0957L7.14219 1.54551C6.41693 1.07802 5.57224 0.829617 4.70937 0.830079H0.6875C0.376367 0.830079 0.125 1.08145 0.125 1.39258V11.377C0.125 11.6881 0.376367 11.9395 0.6875 11.9395H4.70937C5.57246 11.9395 6.41621 12.1873 7.14219 12.6549L7.92266 13.1576C7.94551 13.1717 7.97187 13.1805 7.99824 13.1805C8.02461 13.1805 8.05098 13.1734 8.07383 13.1576L8.8543 12.6549C9.58203 12.1873 10.4275 11.9395 11.2906 11.9395H15.3125C15.6236 11.9395 15.875 11.6881 15.875 11.377V1.39258C15.875 1.08145 15.6236 0.830079 15.3125 0.830079ZM6.10156 7.72949C6.10156 7.80156 6.04531 7.86133 5.97676 7.86133H2.71074C2.64219 7.86133 2.58594 7.80156 2.58594 7.72949V6.93848C2.58594 6.86641 2.64219 6.80664 2.71074 6.80664H5.975C6.04355 6.80664 6.0998 6.86641 6.0998 6.93848V7.72949H6.10156ZM6.10156 5.26856C6.10156 5.34063 6.04531 5.40039 5.97676 5.40039H2.71074C2.64219 5.40039 2.58594 5.34063 2.58594 5.26856V4.47754C2.58594 4.40547 2.64219 4.3457 2.71074 4.3457H5.975C6.04355 4.3457 6.0998 4.40547 6.0998 4.47754V5.26856H6.10156ZM13.4141 7.72949C13.4141 7.80156 13.3578 7.86133 13.2893 7.86133H10.0232C9.95469 7.86133 9.89844 7.80156 9.89844 7.72949V6.93848C9.89844 6.86641 9.95469 6.80664 10.0232 6.80664H13.2875C13.3561 6.80664 13.4123 6.86641 13.4123 6.93848V7.72949H13.4141ZM13.4141 5.26856C13.4141 5.34063 13.3578 5.40039 13.2893 5.40039H10.0232C9.95469 5.40039 9.89844 5.34063 9.89844 5.26856V4.47754C9.89844 4.40547 9.95469 4.3457 10.0232 4.3457H13.2875C13.3561 4.3457 13.4123 4.40547 13.4123 4.47754V5.26856H13.4141Z" />
        </svg>
    ),
    DATA_INVENTORY: (
        <svg
            width="14"
            height="17"
            viewBox="0 0 14 17"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M12.625 0.625H1.375C1.06387 0.625 0.8125 0.876367 0.8125 1.1875V5.125H13.1875V1.1875C13.1875 0.876367 12.9361 0.625 12.625 0.625ZM3.0625 3.57812C2.67402 3.57812 2.35938 3.26348 2.35938 2.875C2.35938 2.48652 2.67402 2.17188 3.0625 2.17188C3.45098 2.17188 3.76562 2.48652 3.76562 2.875C3.76562 3.26348 3.45098 3.57812 3.0625 3.57812ZM0.8125 15.8125C0.8125 16.1236 1.06387 16.375 1.375 16.375H12.625C12.9361 16.375 13.1875 16.1236 13.1875 15.8125V11.875H0.8125V15.8125ZM3.0625 13.4219C3.45098 13.4219 3.76562 13.7365 3.76562 14.125C3.76562 14.5135 3.45098 14.8281 3.0625 14.8281C2.67402 14.8281 2.35938 14.5135 2.35938 14.125C2.35938 13.7365 2.67402 13.4219 3.0625 13.4219ZM0.8125 10.75H13.1875V6.25H0.8125V10.75ZM3.0625 7.79688C3.45098 7.79688 3.76562 8.11152 3.76562 8.5C3.76562 8.88848 3.45098 9.20312 3.0625 9.20312C2.67402 9.20312 2.35938 8.88848 2.35938 8.5C2.35938 8.11152 2.67402 7.79688 3.0625 7.79688Z" />
        </svg>
    ),
    RISK_MANAGEMENT: (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M16 15.0625H15.0625V5.625H12.2188V15.0625H11.2812V9.375H8.46875V15.0625H7.53125V7.5H4.71875V15.0625H3.78125V10.3125H0.9375V15.0625H0V16H16V15.0625Z" />
            <path d="M15.9994 3.75V0H12.2181V0.9375H14.399L9.87438 5.43091L6.12438 1.68091L0.136719 7.63734L0.799531 8.30016L6.12438 3.00659L9.87438 6.75659L15.0619 1.60034V3.75H15.9994Z" />
        </svg>
    ),
    DPIA: (
        <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M12.25 0.5H1.75C0.925 0.5 0.25 1.175 0.25 2V12.5C0.25 13.325 0.925 14 1.75 14H12.25C13.075 14 13.75 13.325 13.75 12.5V2C13.75 1.175 13.075 0.5 12.25 0.5ZM4.75 11H3.25V5.75H4.75V11ZM7.75 11H6.25V3.5H7.75V11ZM10.75 11H9.25V8H10.75V11Z"
                fill="white"
            />
        </svg>
    ),
    COOKIE_MANAGEMENT: (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.20934 18.0018C13.6276 18.0054 17.2123 14.4267 17.216 10.0084C17.2197 5.59016 13.6409 2.00545 9.22265 2.00178C4.80438 1.9981 1.21967 5.57684 1.216 9.99511C1.21232 14.4134 4.79106 17.9981 9.20934 18.0018ZM6.30828 6.20573C6.26866 5.50199 6.71625 4.88399 7.39378 4.70699C7.49282 4.68111 7.61727 4.66769 7.7621 4.66724C8.19294 4.66596 8.49033 4.7886 8.79398 5.09282C8.94652 5.24562 8.99879 5.31517 9.06901 5.45867C9.18019 5.68586 9.21876 5.85521 9.21892 6.11703C9.21924 6.62786 9.02093 6.99972 8.56462 7.34398L8.50944 7.38561L8.64179 7.73994C8.76448 8.06839 8.77779 8.09399 8.824 8.09019C8.8514 8.08794 8.95053 8.07755 9.04427 8.06706C9.38268 8.02925 9.77753 8.1029 10.0924 8.26259C10.2294 8.33203 10.3655 8.42649 10.5362 8.57072L10.6299 8.64985L11.0331 8.35409C11.2549 8.19142 11.5039 8.00862 11.5866 7.94784L11.7368 7.83737L11.6951 7.71698C11.6405 7.55932 11.6228 7.29843 11.6542 7.11603C11.7162 6.75705 11.9786 6.40639 12.3025 6.24983C12.5098 6.14956 12.6475 6.11957 12.8859 6.12275C13.2195 6.12721 13.4765 6.23778 13.7214 6.48225C13.95 6.71042 14.072 7.00846 14.0718 7.33814C14.0715 7.66782 13.949 7.96567 13.72 8.19345C13.56 8.35263 13.4426 8.42595 13.2325 8.49797C12.8778 8.61959 12.4219 8.54262 12.1292 8.31167C12.0824 8.27475 12.041 8.25663 12.0251 8.26611C11.9622 8.30355 10.9251 9.06864 10.9251 9.07758C10.9251 9.08302 10.945 9.12652 10.9692 9.17424C11.2268 9.68014 11.2206 10.3335 10.9534 10.8599C10.9237 10.9184 10.9072 10.9732 10.9167 10.9818C10.9262 10.9904 11.2963 11.2747 11.7392 11.6136L12.5444 12.2298L12.6137 12.178C12.8173 12.0256 13.0754 11.9422 13.3432 11.9425C13.6869 11.9427 13.9485 12.0519 14.1934 12.2972C14.4408 12.5451 14.547 12.804 14.5467 13.1586C14.5465 13.3815 14.5054 13.552 14.4066 13.7403C14.163 14.2041 13.6071 14.4615 13.0874 14.3513C12.3712 14.1993 11.9424 13.4555 12.1792 12.7761L12.2295 12.6319L11.4159 12.0085L10.6023 11.3852L10.4449 11.5117C10.1915 11.7153 9.86949 11.8641 9.56132 11.9199C9.38054 11.9526 9.00038 11.947 8.83941 11.9093C8.66169 11.8676 8.49857 11.8106 8.36888 11.7447L8.26378 11.6913L7.82087 12.2816L7.37796 12.8719L7.47285 13.001C7.67419 13.275 7.76024 13.5367 7.76054 13.8756C7.76104 14.4485 7.4568 14.9418 6.95126 15.188C6.73346 15.294 6.5611 15.3325 6.30343 15.3327C5.96341 15.3329 5.71314 15.2518 5.4276 15.0491C4.86854 14.652 4.68181 13.8726 4.99365 13.2378C5.17582 12.8671 5.45417 12.6223 5.84934 12.4856C5.99889 12.4338 6.04504 12.4278 6.29731 12.4272C6.5642 12.4266 6.58851 12.4302 6.7736 12.4962C6.88089 12.5345 6.9757 12.558 6.98429 12.5484C7.00867 12.5213 7.80898 11.4513 7.82606 11.423C7.83522 11.4078 7.78693 11.329 7.70468 11.2249C7.48872 10.9516 7.33629 10.5921 7.28933 10.2452C7.27703 10.1543 7.27104 10.1461 7.20951 10.1367C7.14745 10.1272 6.40361 10.0822 6.30757 10.0821C6.27495 10.0821 6.25793 10.1029 6.23896 10.1661C6.20683 10.273 6.09492 10.463 5.99768 10.5758C5.95618 10.6239 5.8518 10.7103 5.76575 10.7678C5.27986 11.0922 4.64028 11.0283 4.22784 10.6141C3.99886 10.3842 3.88258 10.0953 3.88286 9.75715C3.88315 9.40773 3.99125 9.13932 4.22726 8.90208C4.6885 8.43841 5.4259 8.41492 5.90731 8.84854C6.07281 8.99761 6.23145 9.25739 6.26796 9.4392C6.2757 9.47765 6.28618 9.52413 6.29127 9.54249C6.29914 9.57083 6.37247 9.57992 6.77826 9.6028C7.04102 9.61761 7.26933 9.62463 7.2856 9.61839C7.3019 9.61215 7.32196 9.57114 7.33018 9.52727C7.40432 9.13172 7.78795 8.60189 8.17127 8.36569C8.2425 8.32181 8.30065 8.28489 8.30053 8.28366C8.3004 8.28243 8.24048 8.12196 8.16737 7.92708L8.03443 7.57274L7.82934 7.57951C7.01234 7.60648 6.35365 7.01156 6.30828 6.20573Z"
                fill="white"
            />
        </svg>
    ),
    DATA_SUBJECT_MANAGEMENT: (
        <svg
            width="15"
            height="16"
            viewBox="0 0 15 16"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M11.3996 2.7C11.3996 4.1913 8.98221 5.4 5.99961 5.4C3.01701 5.4 0.599609 4.1913 0.599609 2.7C0.599609 1.2087 3.01701 0 5.99961 0C8.98221 0 11.3996 1.2087 11.3996 2.7ZM10.2206 5.4144C10.4745 5.28786 10.7182 5.14192 10.9496 4.9779C10.9496 5.7078 10.3232 6.273 9.67881 6.6168C9.31679 6.80981 9.00352 7.08278 8.76279 7.41498C8.52205 7.74718 8.36018 8.12987 8.28948 8.53398C8.21877 8.9381 8.24108 9.35301 8.35472 9.74721C8.46836 10.1414 8.67034 10.5045 8.94531 10.809C8.38621 10.86 7.86636 11.1181 7.48786 11.5328C7.10935 11.9474 6.89954 12.4886 6.89961 13.05C6.89961 13.4865 6.99501 13.9266 7.19661 14.3334C6.7992 14.3783 6.39955 14.4005 5.99961 14.4C3.01701 14.4 0.599609 13.1913 0.599609 11.7V4.608C0.944309 4.9338 1.35561 5.2029 1.77861 5.4144C2.90541 5.9778 4.39941 6.3 5.99961 6.3C7.59981 6.3 9.09381 5.9778 10.2206 5.4144ZM12.7496 9C12.7496 9.47739 12.56 9.93523 12.2224 10.2728C11.8848 10.6104 11.427 10.8 10.9496 10.8C10.4722 10.8 10.0144 10.6104 9.67682 10.2728C9.33925 9.93523 9.14961 9.47739 9.14961 9C9.14961 8.52261 9.33925 8.06477 9.67682 7.72721C10.0144 7.38964 10.4722 7.2 10.9496 7.2C11.427 7.2 11.8848 7.38964 12.2224 7.72721C12.56 8.06477 12.7496 8.52261 12.7496 9ZM14.0996 13.05C14.0996 14.1705 13.1996 15.3 10.9496 15.3C8.69961 15.3 7.79961 14.175 7.79961 13.05C7.79961 12.692 7.94184 12.3486 8.19501 12.0954C8.44819 11.8422 8.79157 11.7 9.14961 11.7H12.7496C13.1077 11.7 13.451 11.8422 13.7042 12.0954C13.9574 12.3486 14.0996 12.692 14.0996 13.05Z" />
        </svg>
    ),
    PRIVACY_POLICY: (
        <svg
            width={16}
            height={18}
            viewBox="0 0 16 18"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M8 8.60377C7.31429 8.60377 6.85714 9.0566 6.85714 9.73585C6.85714 10.1887 7.2 10.5283 7.54286 10.6415L7.2 12.2264H8.68572L8.34286 10.6415C8.8 10.5283 9.02857 10.1887 9.02857 9.73585C9.14286 9.0566 8.68571 8.60377 8 8.60377V8.60377ZM8.11429 3.73585C7.31429 3.73585 6.51429 4.30189 6.51429 5.09434V6.79245H9.6V5.09434C9.48571 4.30189 8.91429 3.73585 8.11429 3.73585V3.73585ZM8 0L0 3.39623V6.79245C0.114286 11.7736 3.31429 16.1887 8 18C12.6857 16.1887 15.8857 11.7736 16 6.79245V3.39623L8 0ZM12.5714 12.4528C12.5714 13.1321 12.1143 13.5849 11.4286 13.5849H4.57143C3.88571 13.5849 3.42857 13.1321 3.42857 12.4528V7.92453C3.42857 7.24528 3.88571 6.79245 4.57143 6.79245H4.91429V5.09434C5.02857 3.50943 6.4 2.26415 8 2.26415C9.6 2.26415 10.9714 3.50943 11.0857 5.09434V6.79245H11.4286C12.1143 6.79245 12.5714 7.24528 12.5714 7.92453V12.4528Z" />
        </svg>
    ),
    CONSENT_MANAGEMENT: (
        <svg
            width="14"
            height="16"
            viewBox="0 0 14 16"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M12.1392 0.0250642L2.38916 0.0169485C1.48466 0.0161957 0.138661 0.614326 0.137287 2.26507L0.128547 12.7651C0.127173 14.4158 1.47217 15.0162 2.37667 15.0169L13.6267 15.0263L13.6279 13.5263L2.38692 13.517C2.04043 13.5077 1.62804 13.3708 1.62855 12.7663C1.62861 12.6906 1.63542 12.6231 1.64672 12.5616C1.73108 12.1297 2.08516 12.0242 2.38817 12.017L13.6292 12.0263L13.6379 1.52631C13.6382 1.12849 13.4805 0.746825 13.1994 0.465287C12.9184 0.183748 12.537 0.0253954 12.1392 0.0250642ZM12.1335 6.77506L10.6342 6.02381L9.13354 6.77256L9.13791 1.52257L12.1379 1.52506L12.1335 6.77506Z" />
        </svg>
    ),
    DATA_BREACH: (
        <svg
            width="18"
            height="19"
            viewBox="0 0 18 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_743_19245)">
                <path
                    d="M9 13.9444C9.25185 13.9444 9.46311 13.8591 9.63378 13.6884C9.80444 13.5178 9.88948 13.3068 9.88889 13.0556C9.8883 12.8043 9.80296 12.5933 9.63289 12.4227C9.46281 12.252 9.25185 12.1667 9 12.1667C8.74815 12.1667 8.53719 12.252 8.36711 12.4227C8.19704 12.5933 8.1117 12.8043 8.11111 13.0556C8.11052 13.3068 8.19585 13.5181 8.36711 13.6893C8.53837 13.8606 8.74933 13.9456 9 13.9444ZM9 10.3889C9.25185 10.3889 9.46311 10.3036 9.63378 10.1329C9.80444 9.96222 9.88948 9.75126 9.88889 9.5V5.94444C9.88889 5.69259 9.80356 5.48163 9.63289 5.31156C9.46222 5.14148 9.25126 5.05615 9 5.05556C8.74874 5.05496 8.53778 5.1403 8.36711 5.31156C8.19644 5.48282 8.11111 5.69378 8.11111 5.94444V9.5C8.11111 9.75185 8.19644 9.96311 8.36711 10.1338C8.53778 10.3044 8.74874 10.3895 9 10.3889ZM6.4 17.5C6.16296 17.5 5.93718 17.4556 5.72267 17.3667C5.50815 17.2778 5.31911 17.1519 5.15556 16.9889L1.51111 13.3444C1.34815 13.1815 1.22222 12.9924 1.13333 12.7773C1.04444 12.5622 1 12.3367 1 12.1009V6.90089C1 6.66385 1.04444 6.43807 1.13333 6.22356C1.22222 6.00904 1.34815 5.82 1.51111 5.65644L5.15556 2.012C5.31852 1.84904 5.50756 1.72311 5.72267 1.63422C5.93778 1.54533 6.16356 1.50059 6.4 1.5H11.6C11.837 1.5 12.0631 1.54444 12.2782 1.63333C12.4933 1.72222 12.6821 1.84815 12.8444 2.01111L16.4889 5.65556C16.6519 5.81852 16.7778 6.00756 16.8667 6.22267C16.9556 6.43778 17 6.66356 17 6.9V12.1C17 12.337 16.9556 12.5631 16.8667 12.7782C16.7778 12.9933 16.6519 13.1821 16.4889 13.3444L12.8444 16.9889C12.6815 17.1519 12.4924 17.2778 12.2773 17.3667C12.0622 17.4556 11.8364 17.5 11.6 17.5H6.4Z"
                    fill="white"
                />
            </g>
            <defs>
                <clipPath id="clip0_743_19245">
                    <rect
                        width="18"
                        height="18"
                        fill="white"
                        transform="translate(0 0.5)"
                    />
                </clipPath>
            </defs>
        </svg>
    ),
    DATA_INQUIRY: (
        <svg
            width="14"
            height="17"
            viewBox="0 0 14 17"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M9.3125 5.1875C8.70941 5.1875 8.21875 4.69684 8.21875 4.09375V0.5H2.625C1.67728 0.5 0.90625 1.27103 0.90625 2.21875V14.7812C0.90625 15.729 1.67728 16.5 2.625 16.5H11.375C12.3227 16.5 13.0938 15.729 13.0938 14.7812V5.1875H9.3125ZM3.46875 11.75H5.74125C6.00012 11.75 6.21 11.9599 6.21 12.2188C6.21 12.4776 6.00012 12.6875 5.74125 12.6875H3.46875C3.20988 12.6875 3 12.4776 3 12.2188C3 11.9599 3.20988 11.75 3.46875 11.75ZM3 9.71875C3 9.45988 3.20988 9.25 3.46875 9.25H10.3438C10.6026 9.25 10.8125 9.45988 10.8125 9.71875C10.8125 9.97762 10.6026 10.1875 10.3438 10.1875H3.46875C3.20988 10.1875 3 9.97762 3 9.71875ZM10.3438 6.75C10.6026 6.75 10.8125 6.95988 10.8125 7.21875C10.8125 7.47762 10.6026 7.6875 10.3438 7.6875H3.46875C3.20988 7.6875 3 7.47762 3 7.21875C3 6.95988 3.20988 6.75 3.46875 6.75H10.3438Z"
                fill="white"
            />
        </svg>
    ),
    CONFIGURATION: (
        <svg
            width="18"
            height="19"
            viewBox="0 0 18 19"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M9.97053 0.500002C10.2351 0.500002 10.4718 0.664702 10.5609 0.911302L11.1963 2.6726C11.424 2.7293 11.6193 2.786 11.7849 2.8454C11.9658 2.9102 12.1989 3.0083 12.4869 3.1424L13.9665 2.3594C14.0873 2.29542 14.2256 2.27232 14.3606 2.29358C14.4956 2.31484 14.6201 2.3793 14.7153 2.4773L16.0167 3.8228C16.1895 4.0019 16.2381 4.2638 16.1409 4.4924L15.447 6.1187C15.5622 6.3302 15.654 6.5111 15.7242 6.6623C15.7998 6.827 15.8934 7.0538 16.005 7.3463L17.6223 8.0393C17.8653 8.1428 18.0156 8.3858 17.9994 8.6459L17.8806 10.5134C17.8725 10.6347 17.8289 10.751 17.7554 10.8478C17.6818 10.9446 17.5814 11.0176 17.4666 11.0579L15.9348 11.6024C15.8907 11.8139 15.8448 11.9948 15.7962 12.1478C15.7178 12.3841 15.6283 12.6166 15.528 12.8444L16.2975 14.5454C16.3518 14.6649 16.3665 14.7987 16.3393 14.9271C16.312 15.0555 16.2444 15.1719 16.1463 15.2591L14.6829 16.5659C14.5866 16.6516 14.4663 16.7058 14.3383 16.7212C14.2102 16.7367 14.0805 16.7126 13.9665 16.6523L12.4581 15.8531C12.2221 15.9781 11.9787 16.0884 11.7291 16.1834L11.0703 16.43L10.4853 18.05C10.442 18.1686 10.3638 18.2714 10.261 18.3448C10.1582 18.4182 10.0356 18.4588 9.90933 18.4613L8.19933 18.5C8.0697 18.5034 7.94219 18.4665 7.83437 18.3945C7.72655 18.3225 7.6437 18.2188 7.59723 18.0977L6.90783 16.2734C6.67261 16.193 6.43972 16.106 6.20943 16.0124C6.02107 15.9309 5.83557 15.8429 5.65323 15.7487L3.94323 16.4795C3.83056 16.5276 3.70634 16.5419 3.5857 16.5206C3.46506 16.4993 3.3532 16.4435 3.26373 16.3598L1.99833 15.1727C1.90412 15.0847 1.83996 14.9693 1.81493 14.8429C1.78989 14.7164 1.80525 14.5853 1.85883 14.468L2.59413 12.866C2.49634 12.6763 2.40568 12.4829 2.32233 12.2864C2.22504 12.0459 2.135 11.8025 2.05233 11.5565L0.441331 11.066C0.310381 11.0264 0.196166 10.9447 0.116422 10.8336C0.0366774 10.7224 -0.00413217 10.588 0.000330722 10.4513L0.0633307 8.7224C0.067815 8.6096 0.103054 8.50017 0.165236 8.40594C0.227418 8.31172 0.314177 8.23628 0.416131 8.1878L2.10633 7.376C2.18463 7.0889 2.25303 6.8657 2.31333 6.7028C2.39824 6.48522 2.49253 6.27142 2.59593 6.062L1.86333 4.514C1.80773 4.39645 1.79085 4.26429 1.81511 4.13653C1.83937 4.00877 1.90351 3.892 1.99833 3.803L3.26193 2.6096C3.35051 2.52606 3.46134 2.46989 3.5811 2.44785C3.70085 2.42582 3.82441 2.43886 3.93693 2.4854L5.64513 3.191C5.83413 3.065 6.00513 2.9633 6.15993 2.8814C6.34443 2.7833 6.59103 2.6807 6.90153 2.57L7.49553 0.913102C7.53944 0.791843 7.61972 0.687095 7.72538 0.61316C7.83105 0.539224 7.95696 0.499706 8.08593 0.500002H9.97053ZM9.02193 6.8171C7.52163 6.8171 6.30573 8.0186 6.30573 9.5018C6.30573 10.985 7.52163 12.1874 9.02193 12.1874C10.5213 12.1874 11.7372 10.985 11.7372 9.5018C11.7372 8.0186 10.5222 6.8171 9.02193 6.8171Z" />
        </svg>
    ),
};

export default MenuList;
